import { useStaticQuery, graphql } from "gatsby"
export const useNewsletter = () => {
  const allNL = useStaticQuery(
    graphql`
      query allNewsletters {
        allNewsletter {
          edges {
            node {
              fields {
                slug
              }
              id
              published
              content
              date_added
            }
          }
        }
      }
    `
  )
  return allNL
}